"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _hoisted_1 = {
    key: 0,
    class: "w-full 2xl:container mx-auto p-4 flex flex-col"
};
const _hoisted_2 = { class: "text-center my-4 uppercase" };
const _hoisted_3 = { class: "text-[24px] font-bold" };
const _hoisted_4 = { class: "text-[20px]" };
const _hoisted_5 = { class: "grid grid-cols-3 gap-4" };
const _hoisted_6 = { class: "bg-gray-darker text-white font-bold p-4 rounded" };
const _hoisted_7 = { class: "bg-white font-bold p-4 rounded" };
const _hoisted_8 = { class: "text-red" };
const _hoisted_9 = { class: "bg-white p-4 rounded" };
const _hoisted_10 = { class: "flex flex-col md:flex-row" };
const _hoisted_11 = { class: "flex items-center md:w-5/6" };
const _hoisted_12 = {
    key: 0,
    class: "font-bold text-red text-[24px] mt-4 uppercase"
};
const _hoisted_13 = { class: "flex grow w-auto md:justify-end mt-3 print:hidden" };
const _hoisted_14 = { class: "flex items-center justify-center gap-2" };
const _hoisted_15 = { class: "text-center" };
const _hoisted_16 = { class: "flex items-center justify-center gap-2" };
const _hoisted_17 = { class: "font-bold text-center" };
const _hoisted_18 = { class: "flex items-center justify-end gap-2" };
const _hoisted_19 = { class: "font-bold text-red text-right" };
const _hoisted_20 = { class: "flex items-center justify-end gap-2" };
const _hoisted_21 = { class: "text-right" };
const _hoisted_22 = { class: "flex items-center justify-end gap-2" };
const _hoisted_23 = { class: "font-bold text-red text-right" };
const _hoisted_24 = {
    key: 1,
    class: "font-bold text-red text-[24px] mt-4 uppercase"
};
const _hoisted_25 = { class: "flex items-center justify-center gap-2" };
const _hoisted_26 = { class: "text-center" };
const _hoisted_27 = { class: "flex items-center justify-center gap-2" };
const _hoisted_28 = { class: "font-bold text-center" };
const _hoisted_29 = { class: "flex items-center justify-end gap-2" };
const _hoisted_30 = { class: "text-right" };
const _hoisted_31 = { class: "flex items-center justify-end gap-2" };
const _hoisted_32 = { class: "font-bold text-red text-right" };
const vue_3 = require("vue");
const ResponsiveTable_vue_1 = __importDefault(require("../../components/ResponsiveTable/ResponsiveTable.vue"));
const shop_1 = require("../../common/utils/shop");
const toastStore_1 = require("../../stores/toast/toastStore");
const securityStore_1 = require("../../stores/security/securityStore");
const i18n_1 = require("../../common/i18n");
const balanceStore_1 = require("../../stores/balance/balanceStore");
const vue_router_1 = require("vue-router");
exports.default = (0, vue_1.defineComponent)({
    __name: 'Balance',
    setup(__props) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o;
        const router = (0, vue_router_1.useRouter)();
        const toastStore = (0, toastStore_1.useToastStore)();
        const securityStore = (0, securityStore_1.useSecurityStore)();
        const balanceStore = (0, balanceStore_1.useBalanceStore)();
        const expiredInvoicesFields = (0, vue_3.ref)([
            {
                key: "invoiceId",
                label: (_a = (0, i18n_1.trans)("invoice_id_expired", "Invoice ID", "balance")) !== null && _a !== void 0 ? _a : "Invoice ID",
                value: "invoiceId",
            },
            {
                key: "createdDate",
                label: (_b = (0, i18n_1.trans)("created_date_expired", "Created Date", "balance")) !== null && _b !== void 0 ? _b : "Created Date",
                value: "createdDate",
            },
            {
                key: "deadlineDate",
                label: (_c = (0, i18n_1.trans)("deadline_date_expired", "Deadline Date", "balance")) !== null && _c !== void 0 ? _c : "Deadline Date",
                value: "deadlineDate",
            },
            {
                key: "lateDays",
                label: (_d = (0, i18n_1.trans)("late_days_expired", "Late Days", "balance")) !== null && _d !== void 0 ? _d : "Late Days",
                value: "lateDays",
            },
            {
                key: "paymentCondition",
                label: (_e = (0, i18n_1.trans)("payment_condition_expired", "Payment Condition", "balance")) !== null && _e !== void 0 ? _e : "Payment Condition",
                value: "paymentCondition",
            },
            {
                key: "totalPrice",
                label: (_f = (0, i18n_1.trans)("total_price_expired", "Total Price", "balance")) !== null && _f !== void 0 ? _f : "Total Price",
                value: "totalPrice",
            },
            {
                key: "settleAmountPrice",
                label: (_g = (0, i18n_1.trans)("settle_amount_price_expired", "Settle Amount Price", "balance")) !== null && _g !== void 0 ? _g : "Settle Amount Price",
                value: "settleAmountPrice",
            },
        ]);
        const notDueInvoicesFields = (0, vue_3.ref)([
            {
                key: "invoiceId",
                label: (_h = (0, i18n_1.trans)("invoice_id_not_due", "Invoice ID", "balance")) !== null && _h !== void 0 ? _h : "Invoice ID",
                value: "invoiceId",
            },
            {
                key: "createdDate",
                label: (_j = (0, i18n_1.trans)("created_date_not_due", "Created Date", "balance")) !== null && _j !== void 0 ? _j : "Created Date",
                value: "createdDate",
            },
            {
                key: "deadlineDate",
                label: (_k = (0, i18n_1.trans)("deadline_date_not_due", "Deadline Date", "balance")) !== null && _k !== void 0 ? _k : "Deadline Date",
                value: "deadlineDate",
            },
            {
                key: "paymentCondition",
                label: (_l = (0, i18n_1.trans)("payment_condition_not_due", "Payment Condition", "balance")) !== null && _l !== void 0 ? _l : "Payment Condition",
                value: "paymentCondition",
            },
            {
                key: "totalPrice",
                label: (_m = (0, i18n_1.trans)("total_price_not_due", "Total Price", "balance")) !== null && _m !== void 0 ? _m : "Total Price",
                value: "totalPrice",
            },
            {
                key: "settleAmountPrice",
                label: (_o = (0, i18n_1.trans)("settle_amount_price_not_due", "Settle Amount Price", "balance")) !== null && _o !== void 0 ? _o : "Settle Amount Price",
                value: "settleAmountPrice",
            },
        ]);
        const balance = (0, vue_3.computed)(() => balanceStore.balance);
        const expiredInvoices = (0, vue_3.computed)(() => { var _a, _b; return (_b = (_a = balance.value) === null || _a === void 0 ? void 0 : _a.expiredInvoices) !== null && _b !== void 0 ? _b : []; });
        const notDueInvoices = (0, vue_3.computed)(() => { var _a, _b; return (_b = (_a = balance.value) === null || _a === void 0 ? void 0 : _a.notDueInvoices) !== null && _b !== void 0 ? _b : []; });
        const shouldFetchBalance = (0, vue_3.computed)(() => {
            return balance.value === null;
        });
        const printPage = () => {
            window.print();
        };
        (0, vue_3.onMounted)(async () => {
            if (shouldFetchBalance.value && securityStore.authenticatedUser !== null) {
                await balanceStore.getBalance(router, { id: securityStore.authenticatedUser.customer.id })
                    .catch((error) => {
                    toastStore.addErrorToast(error.toString());
                });
            }
        });
        return (_ctx, _cache) => {
            var _a, _b, _c;
            return ((0, vue_2.unref)(balance) !== null)
                ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_1, [
                    (0, vue_2.createElementVNode)("div", _hoisted_2, [
                        (0, vue_2.createElementVNode)("div", _hoisted_3, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("your_current_balance", "Your current balance", "balance")), 1),
                        (0, vue_2.createElementVNode)("div", _hoisted_4, (0, vue_2.toDisplayString)((0, vue_2.unref)(shop_1.formatDate)(new Date())), 1)
                    ]),
                    (0, vue_2.createElementVNode)("div", _hoisted_5, [
                        (0, vue_2.createElementVNode)("div", _hoisted_6, [
                            (0, vue_2.createElementVNode)("div", null, (0, vue_2.toDisplayString)((0, vue_2.unref)(balance).currencyCode) + " " + (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("balance", "balance", "balance")), 1),
                            (0, vue_2.createElementVNode)("div", null, (0, vue_2.toDisplayString)((_a = (0, vue_2.unref)(balance).formattedTotal) !== null && _a !== void 0 ? _a : (0, vue_2.unref)(i18n_1.trans)("no_data_available_balance", "No data available", "balance")), 1)
                        ]),
                        (0, vue_2.createElementVNode)("div", _hoisted_7, [
                            (0, vue_2.createElementVNode)("div", null, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("expired", "Expired", "balance")), 1),
                            (0, vue_2.createElementVNode)("div", _hoisted_8, (0, vue_2.toDisplayString)((_b = (0, vue_2.unref)(balance).formattedExpiredTotal) !== null && _b !== void 0 ? _b : (0, vue_2.unref)(i18n_1.trans)("no_data_available_expired", "No data available", "balance")), 1)
                        ]),
                        (0, vue_2.createElementVNode)("div", _hoisted_9, [
                            (0, vue_2.createElementVNode)("div", null, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("not_due", "Not due", "balance")), 1),
                            (0, vue_2.createElementVNode)("div", null, (0, vue_2.toDisplayString)((_c = (0, vue_2.unref)(balance).formattedNotDueTotal) !== null && _c !== void 0 ? _c : (0, vue_2.unref)(i18n_1.trans)("no_data_availabe_not_due", "No data available", "balance")), 1)
                        ])
                    ]),
                    (0, vue_2.createElementVNode)("div", _hoisted_10, [
                        (0, vue_2.createElementVNode)("div", _hoisted_11, [
                            ((0, vue_2.unref)(expiredInvoices).length > 0)
                                ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_12, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("expired_invoices", "Expired Invoices", "balance")), 1))
                                : (0, vue_2.createCommentVNode)("", true)
                        ]),
                        (0, vue_2.createElementVNode)("div", _hoisted_13, [
                            (0, vue_2.createElementVNode)("button", {
                                class: "btn btn-rounded btn-warning h-[48px]",
                                onClick: _cache[0] || (_cache[0] = ($event) => (printPage()))
                            }, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("print", "Print", "customer_product_return_list")), 1)
                        ])
                    ]),
                    ((0, vue_2.unref)(expiredInvoices).length > 0)
                        ? ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(ResponsiveTable_vue_1.default, {
                            key: 0,
                            fields: expiredInvoicesFields.value,
                            "onUpdate:fields": _cache[1] || (_cache[1] = ($event) => ((expiredInvoicesFields).value = $event)),
                            items: (0, vue_2.unref)(expiredInvoices),
                            striped: "",
                            condensed: "",
                            panel: ""
                        }, {
                            "head-createdDate": (0, vue_2.withCtx)(() => [
                                (0, vue_2.createElementVNode)("div", _hoisted_14, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("created_date", "Created Date", "balance")), 1)
                            ]),
                            "cell-createdDate": (0, vue_2.withCtx)(({ item: expiredInvoice }) => [
                                (0, vue_2.createElementVNode)("div", _hoisted_15, (0, vue_2.toDisplayString)(expiredInvoice.createdDate), 1)
                            ]),
                            "head-deadlineDate": (0, vue_2.withCtx)(() => [
                                (0, vue_2.createElementVNode)("div", _hoisted_16, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("deadline_date", "Deadline Date", "balance")), 1)
                            ]),
                            "cell-deadlineDate": (0, vue_2.withCtx)(({ item: expiredInvoice }) => [
                                (0, vue_2.createElementVNode)("div", _hoisted_17, (0, vue_2.toDisplayString)(expiredInvoice.deadlineDate), 1)
                            ]),
                            "head-lateDays": (0, vue_2.withCtx)(() => [
                                (0, vue_2.createElementVNode)("div", _hoisted_18, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("late_days", "Late Days", "balance")), 1)
                            ]),
                            "cell-lateDays": (0, vue_2.withCtx)(({ item: expiredInvoice }) => [
                                (0, vue_2.createElementVNode)("div", _hoisted_19, (0, vue_2.toDisplayString)(expiredInvoice.lateDays), 1)
                            ]),
                            "head-totalPrice": (0, vue_2.withCtx)(() => [
                                (0, vue_2.createElementVNode)("div", _hoisted_20, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("total_price", "Total Price", "balance")), 1)
                            ]),
                            "cell-totalPrice": (0, vue_2.withCtx)(({ item: expiredInvoice }) => [
                                (0, vue_2.createElementVNode)("div", _hoisted_21, (0, vue_2.toDisplayString)(expiredInvoice
                                    .formattedTotalPrice), 1)
                            ]),
                            "head-settleAmountPrice": (0, vue_2.withCtx)(() => [
                                (0, vue_2.createElementVNode)("div", _hoisted_22, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)('remaining_amount_price', 'Remaining Amount', 'balance')), 1)
                            ]),
                            "cell-settleAmountPrice": (0, vue_2.withCtx)(({ item: expiredInvoice }) => [
                                (0, vue_2.createElementVNode)("div", _hoisted_23, (0, vue_2.toDisplayString)(expiredInvoice.formattedRemainingAmount), 1)
                            ]),
                            _: 1
                        }, 8, ["fields", "items"]))
                        : (0, vue_2.createCommentVNode)("", true),
                    ((0, vue_2.unref)(notDueInvoices).length > 0)
                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_24, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("not_due_invoices", "Not Due Invoices", "balance")), 1))
                        : (0, vue_2.createCommentVNode)("", true),
                    ((0, vue_2.unref)(notDueInvoices).length > 0)
                        ? ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(ResponsiveTable_vue_1.default, {
                            key: 2,
                            fields: notDueInvoicesFields.value,
                            "onUpdate:fields": _cache[2] || (_cache[2] = ($event) => ((notDueInvoicesFields).value = $event)),
                            items: (0, vue_2.unref)(notDueInvoices),
                            striped: "",
                            condensed: "",
                            panel: ""
                        }, {
                            "head-createdDate": (0, vue_2.withCtx)(() => [
                                (0, vue_2.createElementVNode)("div", _hoisted_25, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("not_due_invoices_created_date", "Created Date", "balance")), 1)
                            ]),
                            "cell-createdDate": (0, vue_2.withCtx)(({ item: notDueInvoice }) => [
                                (0, vue_2.createElementVNode)("div", _hoisted_26, (0, vue_2.toDisplayString)(notDueInvoice.createdDate), 1)
                            ]),
                            "head-deadlineDate": (0, vue_2.withCtx)(() => [
                                (0, vue_2.createElementVNode)("div", _hoisted_27, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("not_due_invoices_deadline_date", "Deadline Date", "balance")), 1)
                            ]),
                            "cell-deadlineDate": (0, vue_2.withCtx)(({ item: notDueInvoice }) => [
                                (0, vue_2.createElementVNode)("div", _hoisted_28, (0, vue_2.toDisplayString)(notDueInvoice.deadlineDate), 1)
                            ]),
                            "head-totalPrice": (0, vue_2.withCtx)(() => [
                                (0, vue_2.createElementVNode)("div", _hoisted_29, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("not_due_invoices_total_price", "Total Price", "balance")), 1)
                            ]),
                            "cell-totalPrice": (0, vue_2.withCtx)(({ item: notDueInvoice }) => [
                                (0, vue_2.createElementVNode)("div", _hoisted_30, (0, vue_2.toDisplayString)(notDueInvoice
                                    .formattedTotalPrice), 1)
                            ]),
                            "head-settleAmountPrice": (0, vue_2.withCtx)(() => [
                                (0, vue_2.createElementVNode)("div", _hoisted_31, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)('not_due_invoices_remaining_amount', 'Remainig Amount', 'balance')), 1)
                            ]),
                            "cell-settleAmountPrice": (0, vue_2.withCtx)(({ item: notDueInvoice }) => [
                                (0, vue_2.createElementVNode)("div", _hoisted_32, (0, vue_2.toDisplayString)(notDueInvoice.formattedRemainingAmount), 1)
                            ]),
                            _: 1
                        }, 8, ["fields", "items"]))
                        : (0, vue_2.createCommentVNode)("", true)
                ]))
                : (0, vue_2.createCommentVNode)("", true);
        };
    }
});
